export const GET_SEARCH_DATA_REQUEST = '[BILLING_PAGE] GET_SEARCH_DATA_REQUEST'


export const GET_SEARCH_DATA_LIST_REQUEST = '[BILLING_PAGE] GET_SEARCH_DATA_LIST_REQUEST'
export const GET_SEARCH_DATA_LIST_SUCCESS = '[BILLING_PAGE] GET_SEARCH_DATA_LIST_REQUEST'
export const GET_SEARCH_DATA_LIST_FAILED = '[BILLING_PAGE] GET_SEARCH_DATA_LIST_FAILED'

export const GET_BILLING_REPORT_COUNT = '[BILLING_PAGE] GET_BILLING_REPORT_COUNT'
export const GET_BILLING_REPORT_COUNT_SUCCESS = '[BILLING_PAGE] GET_BILLING_REPORT_COUNT_SUCCESS'
export const GET_BILLING_REPORT_COUNT_FAILED = '[BILLING_PAGE] GET_BILLING_REPORT_COUNT_FAILED'


export const RESET_BILLINGPAGE_FORM = '[BILLING_PAGE] RESET_BILLINGPAGE_FORM';